<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper building" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal building">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div class="contentHeader unselectable">
							<div>
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Площадь</span></span>
									<span class="level">
										(<span><span>Уровень {{gameModel.island.buildings.area.level}}</span></span>)
									</span>
								</h2>
								<div class="buildingDescription">
									<span>Войска острова собираются на площади. Отсюда ты можешь отправить их в подкрепление, в набег или на захват других островов.</span>
								</div>
								<img class="buildingHuge buildingType16 tribeId3 level5" src="//iwstatic.g.bsrv.su/img/x.gif" />
							</div>
							<span class="buildingStatusButton type_15">
								<div class="buildingStatus location27 optionMenu">
									<div class="buildingBubble clickable disabledHover">
										<div class="colorLayer notNow enoughRes">
											<div class="labelLayer">
												<span class="buildingLevel">5</span>
											</div>
										</div>
									</div>
								</div>
							</span>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'overview', inactive: tab != 'overview'}" @click="onToggleTab('overview')">
										<div class="content">
											<span>Обзор</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'combat-simulator', inactive: tab != 'combat-simulator'}" @click="onToggleTab('combat-simulator')">
										<div class="content">
											<span>Симулятор сражения</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'farm-list', inactive: tab != 'farm-list'}" @click="onToggleTab('farm-list')">
										<div class="content">
											<span>Избранные цели</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="loadedTab currentTab" v-if="tab == 'overview'">
													<overview :set-tab="subtab" />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'combat-simulator'">
													<combat-simulator />
												</div>
												<div class="loadedTab currentTab" v-if="tab == 'farm-list'">
													<farm-list />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							
							<!-- редактирование войск во всех деревнях в выбранных списках целей -->
							<farm-list-edit-troops v-if="gameModel.buildings.area.farmListEditTroopsShow" />

							<!-- редактирование войск в выбранных деревнях в открытом списке целей -->
							<farm-list-item-edit-troops v-if="gameModel.buildings.area.farmListItemEditTroopsShow" />

							<!-- добавление новой деревни в открытый список целей -->
							<farm-list-add-village v-if="gameModel.buildings.area.farmListAddVillageShow" />

							<!-- редактирование открытого списка целей -->
							<farm-list-edit v-if="gameModel.buildings.area.farmListEditShow" />
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Overview from '@/components/pages/buildings/area/Overview';
import CombatSimulator from '@/components/pages/buildings/area/CombatSimulator';
import FarmList from '@/components/pages/buildings/area/FarmList';

import FarmListEditTroops from '@/components/pages/buildings/area/windowOverlay/FarmListEditTroops';
import FarmListItemEditTroops from '@/components/pages/buildings/area/windowOverlay/FarmListItemEditTroops';
import FarmListAddVillage from '@/components/pages/buildings/area/windowOverlay/FarmListAddVillage';
import FarmListEdit from '@/components/pages/buildings/area/windowOverlay/FarmListEdit';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Площадь | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'overview',
		subtab: '',
		
		villageBackgroundLeft: '0px',
		
		tooltips: {
			1: `<div class="stationedUnitTooltip" ng-init="troopId = getTroopId(group['tribeId'], unitId)">
	<h3>
		<span translate="" options="21"><span>Фаланга</span></span>
		<!-- ngIf: group.unitLevels[unitId] -->
	</h3>
	<div class="horizontalLine"></div>
	<div class="troopDetails">
		<div class="troopIcon">
			<i class="unitMedium gaul unitType1" unit-icon="" big="true" data="group['tribeId'], unitId"></i>
		</div>
		<!-- ngIf: unitId != Troops.TYPE_HERO --><div class="unitAttributes" ng-if="unitId != Troops.TYPE_HERO">
			<span><i class="movement_attack_small_flat_black"></i>15</span>
			<span><i class="unit_defenseInfantry_small_flat_black"></i>40</span>
			<br>
			<span><i class="unit_defenseCavalry_small_flat_black"></i>50</span>
			<span><i class="unit_capacity_small_flat_black"></i>35</span>
		</div><!-- end ngIf: unitId != Troops.TYPE_HERO -->
		<!-- ngIf: unitId == Troops.TYPE_HERO -->
	</div>
	<!-- ngIf: unit['distribution']['own'] -->
	<!-- ngRepeat: support in unit['distribution']['support'] track by $index -->
	<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
</div>`,
			2: `<div class="stationedUnitTooltip" ng-init="troopId = getTroopId(group['tribeId'], unitId)">
	<h3>
		<span translate="" options="22"><span>Мечник</span></span>
		<!-- ngIf: group.unitLevels[unitId] -->
	</h3>
	<div class="horizontalLine"></div>
	<div class="troopDetails">
		<div class="troopIcon">
			<i class="unitMedium gaul unitType2" unit-icon="" big="true" data="group['tribeId'], unitId"></i>
		</div>
		<!-- ngIf: unitId != Troops.TYPE_HERO --><div class="unitAttributes" ng-if="unitId != Troops.TYPE_HERO">
			<span><i class="movement_attack_small_flat_black"></i>65</span>
			<span><i class="unit_defenseInfantry_small_flat_black"></i>35</span>
			<br>
			<span><i class="unit_defenseCavalry_small_flat_black"></i>20</span>
			<span><i class="unit_capacity_small_flat_black"></i>45</span>
		</div><!-- end ngIf: unitId != Troops.TYPE_HERO -->
		<!-- ngIf: unitId == Troops.TYPE_HERO -->
	</div>
	<!-- ngIf: unit['distribution']['own'] -->
	<!-- ngRepeat: support in unit['distribution']['support'] track by $index -->
	<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
</div>`,
			3: `<div class="stationedUnitTooltip" ng-init="troopId = getTroopId(group['tribeId'], unitId)">
	<h3>
		<span translate="" options="24"><span>Тевтатский гром</span></span>
		<!-- ngIf: group.unitLevels[unitId] -->
	</h3>
	<div class="horizontalLine"></div>
	<div class="troopDetails">
		<div class="troopIcon">
			<i class="unitMedium gaul unitType4" unit-icon="" big="true" data="group['tribeId'], unitId"></i>
		</div>
		<!-- ngIf: unitId != Troops.TYPE_HERO --><div class="unitAttributes" ng-if="unitId != Troops.TYPE_HERO">
			<span><i class="movement_attack_small_flat_black"></i>90</span>
			<span><i class="unit_defenseInfantry_small_flat_black"></i>25</span>
			<br>
			<span><i class="unit_defenseCavalry_small_flat_black"></i>40</span>
			<span><i class="unit_capacity_small_flat_black"></i>75</span>
		</div><!-- end ngIf: unitId != Troops.TYPE_HERO -->
		<!-- ngIf: unitId == Troops.TYPE_HERO -->
	</div>
	<!-- ngIf: unit['distribution']['own'] -->
	<!-- ngRepeat: support in unit['distribution']['support'] track by $index -->
	<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
</div>`,
			4: `<div class="stationedUnitTooltip" ng-init="troopId = getTroopId(group['tribeId'], unitId)">
	<h3>
		<span translate="" options="25"><span>Друид-всадник</span></span>
		<!-- ngIf: group.unitLevels[unitId] -->
	</h3>
	<div class="horizontalLine"></div>
	<div class="troopDetails">
		<div class="troopIcon">
			<i class="unitMedium gaul unitType5" unit-icon="" big="true" data="group['tribeId'], unitId"></i>
		</div>
		<!-- ngIf: unitId != Troops.TYPE_HERO --><div class="unitAttributes" ng-if="unitId != Troops.TYPE_HERO">
			<span><i class="movement_attack_small_flat_black"></i>45</span>
			<span><i class="unit_defenseInfantry_small_flat_black"></i>115</span>
			<br>
			<span><i class="unit_defenseCavalry_small_flat_black"></i>55</span>
			<span><i class="unit_capacity_small_flat_black"></i>35</span>
		</div><!-- end ngIf: unitId != Troops.TYPE_HERO -->
		<!-- ngIf: unitId == Troops.TYPE_HERO -->
	</div>
	<!-- ngIf: unit['distribution']['own'] -->
	<!-- ngRepeat: support in unit['distribution']['support'] track by $index -->
	<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
</div>`,
			5: `<div class="stationedUnitTooltip" ng-init="troopId = getTroopId(group['tribeId'], unitId)">
	<h3>
		<span translate="" options="26"><span>Эдуйская конница</span></span>
		<!-- ngIf: group.unitLevels[unitId] -->
	</h3>
	<div class="horizontalLine"></div>
	<div class="troopDetails">
		<div class="troopIcon">
			<i class="unitMedium gaul unitType6" unit-icon="" big="true" data="group['tribeId'], unitId"></i>
		</div>
		<!-- ngIf: unitId != Troops.TYPE_HERO --><div class="unitAttributes" ng-if="unitId != Troops.TYPE_HERO">
			<span><i class="movement_attack_small_flat_black"></i>140</span>
			<span><i class="unit_defenseInfantry_small_flat_black"></i>60</span>
			<br>
			<span><i class="unit_defenseCavalry_small_flat_black"></i>165</span>
			<span><i class="unit_capacity_small_flat_black"></i>65</span>
		</div><!-- end ngIf: unitId != Troops.TYPE_HERO -->
		<!-- ngIf: unitId == Troops.TYPE_HERO -->
	</div>
	<!-- ngIf: unit['distribution']['own'] -->
	<!-- ngRepeat: support in unit['distribution']['support'] track by $index -->
	<!-- ngIf: unit['distribution']['others']['sum'] > 0 -->
</div>`,
		},
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab){
			this.tab = tab;
			
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		
		onResize(){
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 325;
			maxHeightContent = (maxHeightContent < 550 ? 550 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted(){
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if(this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: Object.assign({}, this.$route.query, {
			tab: this.tab,
		})});
		
		if(this.$route.query.subtab) this.subtab = this.$route.query.subtab;
	},
	unmounted(){
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next){
		if(!to.query.tab) this.$router.push({query: Object.assign({}, this.$route.query, {
			tab: 'overview',
		})});
		else if(to.query.tab != this.tab) this.tab = to.query.tab;
		
		if(to.query.subtab != this.subtab) this.subtab = to.query.subtab;
		
		next();
	},
	created(){
		this.gameModel.buildingQueue.show = true;
	},
	components: {
		Overview,
		CombatSimulator,
		FarmList,
		
		FarmListEditTroops,
		FarmListItemEditTroops,
		FarmListAddVillage,
		FarmListEdit,
	},
}
</script>